<template>
  <div class="my-courses__container">
    <h2 class="my-courses__heading">
      {{ heading }}
    </h2>

    <div class="my-courses__items-container">
      <template v-if="courses && courses.length > 0">
        <b-table
          borderless
          responsive
          :fields="fields"
          :items="courses"
          class="my-courses__items-table custom-table">
          <template v-slot:cell(actions)="data">
            <div class="my-courses__actions-container">
              <form method="POST"
                    target="_blank"
                    action="/umbraco/surface/Courses/CourseSubmit">
                <input type="hidden"
                       name="url"
                       :value="data.item.instanceUrl">
                <input type="hidden"
                       name="token"
                       :value="data.item.token">
                <input type="hidden"
                       name="username"
                       :value="data.item.username">
                <input type="hidden"
                       name="password"
                       :value="data.item.password">
                <input type="hidden"
                       name="courseId"
                       :value="data.item.externalCourseReference">
                <button class="btn btn-sm btn-accent-1"
                        aria-label="Submit course"
                        type="submit">
                  {{ buttonText }}
                </button>
              </form>
            </div>
          </template>
        </b-table>
      </template>
      <template v-else>
        <div class="my-courses__empty">
          <span>No courses found.</span>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
export default {
  name: "CoursesTable",

  props: {
    heading: {
      type: String,
      required: true
    },
    buttonText: {
      type: String,
      required: true
    },
    fields: {
      type: Array,
      required: true
    },
    courses: {
      type: Array,
      default: () => []
    }
  }
};
</script>
